import { CookieConsent } from '@wrisk/ui-components'
import React, { FunctionComponent, PropsWithChildren } from 'react'
import { Route, Routes } from 'react-router'

import { AppPath } from '../application/AppPath'
import { usePrincipal } from '../application/authentication'
import { WriskTrans } from '../application/organisms/trans'
import { TKey, useWriskTranslation } from '../infrastructure/internationalisation'
import { AdminNav } from './AdminNav'
import { UserNav } from './UserNav'

const tKey = TKey('components.cookie-consent')

const UserNavRoutes: FunctionComponent = () => (
  <Routes>
    <Route
      key='retrieve'
      path={AppPath.RETRIEVE}
      element={<UserNav accountNavEnabled={false} />}
    />
    <Route key='default' path='*' element={<UserNav accountNavEnabled={true} />} />
  </Routes>
)

export interface BasePageProps extends PropsWithChildren {
  cookieDomain: string
}

export const BasePage: FunctionComponent<BasePageProps> = ({
  cookieDomain,
  children,
}) => {
  const { t } = useWriskTranslation()
  const { isAdmin, isAuthenticated } = usePrincipal()

  const Nav = isAdmin ? AdminNav : UserNavRoutes

  return (
    <>
      <Nav />
      {children}
      {!isAuthenticated && !isAdmin && (
        <CookieConsent
          header={t(tKey('header'))}
          content={<WriskTrans t={t} i18nKey={tKey('content')} />}
          acceptAction={t(tKey('actions.accept'), { defaultValue: null })}
          dismissAction={t(tKey('actions.dismiss'), { defaultValue: null })}
          cookieDomain={cookieDomain}
        />
      )}
    </>
  )
}
